1<template>
    <tr class="table__row">
        <td class="table__col">
            <span class="table__col-label">№ тендера</span>
            <span class="table__col-cont">№{{ item.id || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Тип закупки</span>
            <span class="table__col-cont">{{ item.type.name || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Наименование тендера</span>
            <span class="table__col-cont">{{ item.name || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Товаров в&nbsp;тендере</span>
            <span class="table__col-cont">{{ item.productsCount || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Начало торгов</span>
            <span class="table__col-cont">{{ item.auctionStart || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Окончание торгов</span>
            <span class="table__col-cont">{{ item.auctionEnd || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Место доставки</span>
            <span class="table__col-cont">{{ item.deliveryDestination || '-' }}</span>
        </td>
        <td class="table__col">
            <span class="table__col-label">До завершения</span>
			<span v-if="!['Отменён', 'Завершён', 'Подведение итогов', 'Новый'].includes(item.status?.name)" class="table__col-cont">{{ deadLineInDays }}</span>
			<span v-else class="table__col-cont">-</span>
        </td>
        <td class="table__col table__col--status">
            <span class="status" :data-status="item?.status?.name">{{ item.status?.name || '-' }}</span>
        </td>
        <td class="table__col table__col--btn">
            <div class="table__btns">
                <button class="icon-btn icon-btn--fav" :class="{active: item.isFavorite}" @click="handleToggleFavorite"></button>
                <a class="link" :href="item.detailUrl">Подробнее</a>
            </div>
        </td>
    </tr>
    <tr class="table__margin">
        <td colspan="100%"></td>
    </tr>
    <tr class="table__margin">
        <td colspan="100%"></td>
    </tr>

</template>

<script>
import {mapActions} from "vuex";
import {getNoun} from "@/utils/helpers";
import moment from 'moment';


export default {
    name: "SupplyTendersRow",
    props: {
      item: {
          type: Object,
          required: true,
      }
    },
	data() {
		return {
			moment: moment,
		}
	},

    computed: {
		deadLineInDays() {
			const date = moment(this.item?.auctionEnd, 'DD.MM.YYYY HH:mm');
			date.hour(0)
			const endDate = date.diff(moment(), 'days') + 1;

			if (endDate < 1) return '-'
			return  endDate + ' ' + getNoun(endDate, 'день', 'дня', 'дней')
		},
    },
    methods: {
        async handleToggleFavorite() {
            if (this.item.isFavorite) {
                await this.requestDeleteTenderFromFavorites(this.item.id);
            } else {
                await this.requestAddTenderToFavorites(this.item.id);
            }
        },
        ...mapActions({
            requestAddTenderToFavorites: 'tenders/requestAddTenderToFavorites',
            requestDeleteTenderFromFavorites: 'tenders/requestDeleteTenderFromFavorites',
        })
    }
}
</script>


